import type { FaireProductEntity } from "../../entity_types/product";

export const p_dgcnr3tr8h: FaireProductEntity = {
  token: "p_dgcnr3tr8h",
  type: "product",
  name: "Blaze It & Praise It Shirt",
  brandToken: "b_tacvsj4rz9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cee0014c15043bc7c43d51ef6c1084671fd3ca02307af090d2be8630300523f9.png",
  galleryImageUrls: [],
  priceDollars: 27.72,
  description:
    "These are a unisex fit running very true to size but even comfier when worn in a size or two larger. ",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:26.359Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
